import { DateFormats } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService } from '@uplift/services';
import { createDobFieldValidation } from '@uplift/ui-v2';
import * as Yup from 'yup';
import { useSaveProfile } from '../../hooks';
import { useUpdateSettings } from '../../hooks/use-update-settings.hook';
import { useUserProfileQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';

export type DobFormType = {
  dob: string | null;
};

export const useDobForm = () => {
  const me = useCurrentuser();
  const { data: profile } = useUserProfileQuery(me.id, { suspense: true });
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettings();
  const saveProfile = useSaveProfile();

  const dobFormik = () => {
    const initialValues: DobFormType = {
      dob: profile.dob ? CalendarDateService.date(profile.dob).format(DateFormats.DEFAULT_DATE) : ''
    };

    const validationSchema = Yup.object({
      dob: createDobFieldValidation(l10n),
    });

    const onSubmit = async (values: DobFormType) => {
      try {
        await saveProfile({
          dateOfBirth: values.dob
        });

        onFormSubmitSuccess();
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { dobFormik };
};
